import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import Button from './ui/Button';

const Hero = () => {
  const scrollToForm = () => {
    document.getElementById('download-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-brand-dark text-brand-white pt-24 pb-20 md:pt-32 md:pb-32 overflow-hidden">
      {/* Background Accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-yellow/5 to-transparent pointer-events-none" />
      
      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          <div className="flex-1 text-center lg:text-left">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-yellow/10 text-brand-yellow text-sm font-semibold mb-6">
                <SafeIcon name="BookOpen" /> Free 14-Page Guide
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-balance">
                The 10 Most <span className="text-brand-yellow">Dangerous</span> Phrases in Relationships (Decoded)
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 mb-8 font-light text-balance">
                What they say. What they mean. <strong className="text-white font-semibold">Exactly what to say back.</strong>
              </p>
              
              <div className="mb-8">
                <Button onClick={scrollToForm}>
                  GET FREE GUIDE — DOWNLOAD INSTANTLY
                </Button>
              </div>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 text-sm text-gray-400 font-medium">
                <span className="flex items-center gap-1.5"><SafeIcon name="Check" className="text-brand-yellow" /> 14 pages</span>
                <span className="flex items-center gap-1.5"><SafeIcon name="Check" className="text-brand-yellow" /> Instant PDF</span>
                <span className="flex items-center gap-1.5"><SafeIcon name="Check" className="text-brand-yellow" /> 100% free</span>
                <span className="flex items-center gap-1.5"><SafeIcon name="Check" className="text-brand-yellow" /> No spam, ever</span>
              </div>
            </motion.div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none relative perspective-1000">
            <motion.div
              initial={{ opacity: 0, rotateY: 20, x: 50 }}
              animate={{ opacity: 1, rotateY: 0, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative rounded-lg overflow-hidden shadow-2xl shadow-brand-yellow/10 border border-white/10 bg-brand-darker aspect-[3/4] flex items-center justify-center group"
            >
              {/* Mockup Design */}
              <div className="absolute inset-0 bg-gradient-to-br from-brand-dark to-brand-darker p-8 flex flex-col justify-between border-l-8 border-brand-yellow">
                <div className="space-y-4">
                  <div className="w-12 h-1 bg-brand-yellow mb-8"></div>
                  <h3 className="text-3xl font-bold uppercase tracking-tight leading-none">The 10 Most Dangerous Phrases</h3>
                  <p className="text-gray-400 uppercase tracking-widest text-xs">Decoded</p>
                </div>
                <div className="space-y-2 relative z-10">
                  <div className="h-0.5 w-full bg-white/10"></div>
                  <div className="flex justify-between text-[10px] text-gray-500 uppercase tracking-wider">
                    <span>Vol. 1</span>
                    <span>Translation Table</span>
                  </div>
                </div>
                {/* Decorative circles */}
                <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-brand-yellow/5 rounded-full blur-3xl group-hover:bg-brand-yellow/10 transition-colors duration-700"></div>
              </div>
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;